import { ANALYTIC_BASE_URL, AOJ_BASE_URL, DAT_BASE_URL, REVIEW_BASE_URL } from './config'

export const request =
  (type: 'AOJ' | 'DAT' | 'ANALYTIC' | 'REVIEW') =>
  (path: string, option = {}) =>
    fetch(
      `${
        type === 'AOJ'
          ? AOJ_BASE_URL
          : type === 'DAT'
            ? DAT_BASE_URL
            : type === 'ANALYTIC'
              ? ANALYTIC_BASE_URL
              : type === 'REVIEW'
                ? REVIEW_BASE_URL
                : ''
      }/${path}`,
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'include',
        // credentials: 'omit',
        headers: {
          'content-type': 'application/json'
        },
        ...option
      }
    )
